export const translations = {
    en: {
        locale: 'en',
        messages: {
            /************************************************************************* Navigator ***************************************************************************************/
            menu: "MENU",
            home: 'Home',
            about: 'About',
            blog: "Blog",
            specialties: 'Specialties',
            featured_specialties: 'Featured Specialties',
            doctors: 'Doctors',
            contact: 'Contact',
            offers: 'Offers',
            offer: 'Offer',
            login: "Login",
            cash_back: "Cash back",
            visit_day: "visit day",
            add_review: "add review",
            canceled: "canceled",
            my_appointment: "my appointment",
            rate_doctor: "rate doctor",
            write_review: "write review",
            write_your_review_here: "write your review here",
            thank_you: "Thank you",
            review_added_successfully: "Your review added successfully",
            sorry: "Sorry",
            forget_password: "Forget Password",
            new_password: "New Password",
            points: "points",
            logout: "Logout",
            profile: "Profile",
            verify_code: "Verify code",
            type: "Type",
            resend_code: "Resend Code",
            mobileValidationMsg: "Please lengthen this text to 11 numbers or more",
            fees_included: "Fees included",
            keywordPlaceHolder: "Do you know doctor name ?",
            edit: "Edit",
            recommended_by: "Recommended by",
            reviews: "Review",
            premium_fees: "Premium fees",
            show_more: "Show more",
            show_less: "Show less",
            please_login: "Please login to follow this doctor",
            history: "history",
            load_more: "load more",
            book_now: "Book now",
            open_app: "Open app",
            login_first: "You should login first",
            link_copied: "Link copied successfully",
            expires_on: "Expires on",
            days: "days",
            offer_category: "offer category",
            speciality: "speciality",
            subtotal_fees: "subtotal fees",
            total_fees: "total fees",
            cash_back_requested_successfully: "Cash back requested successfully",
            copy_offer_link: "copy offer link",
            copy_doctor_profile_link: "copy doctor profile link",
            doctor_profile_link_copied_successfully: "Doctor profile link copied successfully",
            offer_link_copied_successfully: "Offer link copied successfully",
            share_on: "Share On",
            verify: "verify",
            verified: "verified",
            become_premium_by_sharing: "become premium by sharing",
            become_premium_by_sharing_text: "Get premium by inviting your friends to sign up with Seena.When friends sign up with your invite code, they get one premium month for free, once a friend has signed up with Seena, you get one premium month for free.You can share your code by tapping share now and selecting one of the options available.",
            you_logged_in_successfully: "You are logged in successfully",
            branch_info: "branch info",
            branch: "branch",
            premium_users_only: "premium users only",
            search_for_doctor: "search for doctor",
            find_the_best_doctor_now_easily: "find the best doctor now easily",
            find_doctor_now: "find doctor now",
            account: "account",
            create_account: "create account",
            opps_page_is_not_available: "opps page is not available",
            reload: "reload",
            /********************************************************************* Page Titles ***************************************************************************************/
            home_title: "Save Time And Money",
            about_title: "About",
            contact_title: "Contact",
            doctors_title: "Book with your doctor so easily",
            specialties_title: "Specialties",
            privacy_title: 'Privacy Policy',
            terms_title: 'Terms and Agreement',
            blog_title: "Blog",
            offers_title: "Offers",
            join_our_doctors_title: "Join our doctors now and enjoy our benefits",
            doctors_favourite_title: "Helping Doctor Save Lives",
            offer_details_title: "Offer Details",
            blog_category_title: "Blog Categories",
            blog_tag_title: "Blog Tags",
            blog_post_title: "Blog Post",
            profile_title: 'Profile',
            my_appointments_title: 'Appointments',
            download_title: "Download App",
            single_doctor_title: "Doctor",
            premium_title: "Premium",
            cash_back_title: "Cash Back",
            login_title: "Login",
            register_title: "Register",
            activate_title: "Activate",
            forget_password_title: 'Forget Password',
            reset_password_title: 'Reset Password',
            no_match_title: "404",

            /******************************************************************** slider ***************************************************************************/


            // Subscribe
            subscribe: "Subscribe",
            subscribe_Text: "To Get our Latest News and Offers. Please subsribe with your email.",
            enter_your_email_address: "Enter your email address",


            // specialties
            specialities: "Specialties",


            /*****************Contact Us*********************/
            Contact_Information: "Contact Information",
            address: "Address",
            address_details: "21 Ibrahim El-Refaey, Nasr City, Egypt",
            name: "Name",
            email: "Email",
            mobile: "Mobile",
            message: "Message",
            send_message: "send message",

            /*****************Footer*********************/
            important: "Important",
            how_to_register: "How to register?",
            already_have_account: "Already have an account ?",
            privacy_policy: "Privacy Policy",
            site_links: "Site Links",
            have_questions: "Have a Questions?",
            copyright: "Copyright all rights reserved to RK Anjel",
            premium_footer: "Premium",
            points_footer: "Points",
            /**************************************************************** */
            /*************************************************************** */

            /********** About Rklinic *************** */
            about_header: "Welcome to the ultimate medical meeting point!",
            about_paragragh_1: "A Doctor or a patient, what could be better than a custom made Application just for you? RKlinic has just created the right-in-your-pocket application that will help both doctors and their patients to communicate easier and better. Get to know your Application and its features.",
            about_paragragh_2: "Our application was made for doctors who care, work and strive to help people and people alone! That alone will help doctors to create a more comfortable environment for patients to feel closer and more related to the entire medical process.",


            /************************* General Translations */
            phone: " Phone ",
            book: "Book",
            fetch_more: "Show More",
            no_data: "No data to show ..",
            fees: 'Fees',
            followers: 'followers',
            msg_sent: "Message Sent",
            msg_sent_details: "Message has been sent successfully ..",
            doctors_will_be_here: "Our doctors will be here ..",
            currency: "EGP",
            advance_filter: "Filter",
            aToz: "Sort (A to Z)",
            zToa: "Sort (Z to A)",
            select_specialty: "Select Specialty",
            recommendations: "Recommendations",
            sort: "Sort",
            doctor_name: "Doctor Name",
            city: "city",
            province: "province",
            specialty: "specialty",
            poly_clinics: "Poly Clinic",
            404: "Error 404",
            page_not_found: "The page you're looking for can't be found",
            booking_is_not_available: "Booking is not available yet",
            sponsored: "Sponsored",
            off: "Off",
            not_login_request_plan_title: "You are a guest",
            not_login_request_plan_text: "You must login first",
            change_plan_request_title: "Change your plan",
            change_plan_request_text: "Are you sure to change your plan ?",
            /************************************Home***********************/
            /************Intro*************/
            home_intro_title: "Save money and time on your medical services",
            home_intro_sub_title: "Whether you have a medical insurance or waiting for medical approval; we have you covered",
            search_for_doctors: "BOOK NOW",

            /***************WorkProcess*********/
            work_process_header: "How to use Seena ?",
            wp_search_for_doctor: "Select your doctor",
            wp_search_for_doctor_desc: "Select your doctor",
            wp_cash_back: "Cash back",
            wp_cash_back_desc: "Get cash back on your transactions",
            wp_book_appointment: "Schedule",
            wp_book_appointment_desc: "Schedule your appointments",
            wp_track_visit: "Monitor your turn",
            wp_track_visit_desc: "Monitor your turn and save time",

            /***************Offer*********/
            offer_header: "Our offers",

            /***************Blog*********/
            blog_header: "Recent Blog Posts",

            /************************************Doctor***********************/
            search: "Search",
            followed_by: "Followed by",
            min_fees: "Min fees",
            user: "user",
            upcoming: "upcoming",
            past: "past",
            get_cash_back: "get cash back",
            not_enough_points: "Not Enough Balance",
            /************************************Single Doctor***********************/
            cancel: "Cancel",
            check_up: "Check up",
            follow_up: "Follow up",
            write_complaint: "Write a complaint ..",
            vat: "VAT",
            discount: "Discount",
            total: "Total",
            submit: "Submit",
            approved: "Approved",
            patient_number: "Patient Number",
            now_serving: "Now Serving",
            track_reservation: "Track your reservation, download Seena",
            download: "download",
            here: "Here",
            done: "Done",
            premium: "premium",
            doctor: "Doctor",
            biography: "Biography",
            services: "Services",
            choose_day: "Choose a day",
            choose_time: "Choose a time",
            previous: "previous",
            next: "next",
            from: "From",
            to: "To",
            queue_reservation_hint: "First booked first In",
            interval_reservation_hint: "Attendance in a specific time",
            break_times: "Break Times",
            view: "View",
            views: "Views",
            insurance_companies: "Insurance companies",
            clinic_gallery: "Clinic Photos",
            /************************BLOG******************************/
            website: "Website",
            your_comment: "Your Comment",
            post_comment: "Post Comment",
            categories: "Categories",
            tag_cloud: "Tag Cloud",
            reply: "Reply",
            leave_reply: "Leave a reply",
            comments: "Comments",
            leave_comment: "Leave a Comment",

            /********************Offer******************************/
            get_offer: "Get Offer",
            users_booked: "Clients booked",
            /******************ActivateForm******************************/
            code_not_match: "Code does't match",
            activate: "Activate",
            back_to_home: "Back to home",

            /******************Login******************************/
            sign_up_now_ques: "Sign up now ?",
            forget_your_password_ques: "Forget your password?",

            /******************Register******************************/
            register: "Register",
            sign_up: "Sign up",
            have_account_ques: "Have an account?!",

            /******************Download******************************/
            download_seena_app: "Download Seena Now",
            available_on_store: "Available from the Apple App Store, Google Play Store.",
            free_download_desc: " Seena is free to download and free to use. Search for doctors in many specialities by just on click.",
            seena_for_doctors_available: "Seena for doctors is available on",
            seena_for_doctors: "Seena For Doctors",
            seena_for_doctors_desc: "Our product provides you with a professional admin portal to manage you account, ",
            seena_for_doctors_desc_two: "with ease in mind, it is a very powerful, user friendly portal.",
            ios: "iOS",
            android: "Android",
            sign_up_now: "Sign up now",

            /******************premium benefits******************************/
            benefits: "Benefits",
            enjoy_unlimited_discount: "Enjoy Unlimited Discounts",
            no_medical_approval: "No Medical Approval",
            no_medical_approval_desc: "Get discounts on medical services that do not need any medical insurance approval.",
            special_discounts: "Special discounts",
            special_discounts_desc: "Save more money on the doctors prices by having extra discount.",
            personal_data: "Personal data",
            personal_data_desc: "Keep your electronic medial records with you everywhere you go.",
            all_terrain_suitability: "Bonus points",
            all_terrain_suitability_desc: "Get more points on the same amount of money spent on your clinic.",
            upgrade_now: "Upgrade Now",

            /******************Profile******************************/
            followed_doctors: "Followed Doctors",
            edit_profile: "Edit Profile",
            main_info: "Main Info",
            extras: "Extras",
            months: "Month(s)",
            gender: "Gender",
            male: "Male",
            female: "Female",
            height: "Height",
            weight: "Weight",
            birthday: "Birth date",
            upgrade_to_premium: "Upgrade to premium",
            upcoming_appointments: "Upcoming Appointments",
            delete: "Delete",
            reschedule: "Reschedule",
            completed: "Completed",
            not_found: "Not Found",
            from_points: "From : ",
            to_points: "to : ",
            cancel_reservation: "Cancel Reservation",
            /*********************************POINTS**********************/
            points_title: "Earn cash to get benefits",
            points_benefit_one: "Extra Discounts",
            points_benefit_one_desc: "Get up to 50% discounts from the doctors in the premium network",
            points_benefit_two: "Extra cash back",
            points_benefit_two_desc: "Get up up to 3% cash back on all of your transactions through Seena",
            points_benefit_three: "Extra Products",
            points_benefit_three_desc: "Access more products in the market place to redeem with your points",
            points_benefit_four: "Free check ups",
            points_benefit_four_desc: "Get free check ups from doctors providing them in our doctors premium network",
            get_plan_with_points: "Or you can get it with",
            get_plan: "Get Plan",
            point_s: "Point(s)",
            credit_card: "Credit Card",
            get_more_points: "get more points",
            ok: "Ok",
            something_wrong: "Ops, Something went wrong",
            join_our_doctors: "Join Our Doctors",
            are_you_sure_ques: "Are you sure ?",
            cancel_plan_sweet_alert_title: "Cancel plan !!",
            cancel_plan_sweet_alert_text: "Are you sure to cancel your plan ?",
            expired_on: "Expired on",
            success_plan: "You have upgraded to this plan successfully",
            success: "Success",
            get_points: "get points",
            top_offers: "Top Offers",
            Book_in_branch: "Book in",
            contact_address: "address : ",
            contact_phone: "phone : ",
            contact_email: "email : ",

            active: "Active",
            active_account: "active account",
            activated_successfully: "Activated successfully",

            auth_pop_up_sweet_alert_title: "Quick login",
            auth_pop_up_sweet_alert_text: "You should login OR register now to reserve",
            activation_pop_up_sweet_alert_title: "Quick activation",
            activation_pop_up_sweet_alert_text: "You should activate your account to reserve",

            go_home: "Go home",

            payment_terms_title: "payment terms and conditions",

            add_services: "add services",

            optional: "optional",

            discount_premium_user: "discount is valid only for premium users",

            are_you_sure: "Are you sure ?",
            are_you_sure_you_want_get_this_plan: "Are you sure you want get this plan ?",
            yes: "Yes",

            report: "report",
            missed: "missed",
            review: "review",
            ad: "ad",
            top_viewed: "top viewed",
            refund: "refund",
            why_do_you_want_to_report_this_visit : "why do you want to report this visit ?",
            select_issue: "select issue",
            help: "help",
            or_call_us: "or call us",
            report_added_successfully: "Report sent successfully",
            promo_code: "promo code",
            enter_your_promo_code: "enter your promo code",
            redeem: "redeem",
            payment_methods: "payment methods",
            cash: "cash",
            instalment: "instalment",
            cash_back_desc: "get 10% cash back after your visit",
            instalment_desc: "fill your credit card number to show the available plans for your bank",
            code_required: "Code is required",

            all: "All",
            most_viewed: "most viewed",
            agree: "agree",
            request_refund_success: "Request sent successfully",
            dont_agree: "don't agree",
            transaction_id: "transaction id",
            expires_today: "expires today",
            refund_desc : "If you are a patient and suffer a reservation Issue, we agree, at our discretion, to either (i) reimburse you up to the amount paid by you through the Seena Platform (“Total Fees Or Less”) depending on the nature of the reservation Issue suffered",

            different_specialities: "different specialities",

            credit_card_instalment: "instalment plans available as low as 0% interset"
        }
    },

    /*************************** */

    ar: {
        locale: 'ar',
        messages: {
            /************************************************************************* Navigator ***************************************************************************************/
            menu: "قائمة",
            home: 'الرئيسية',
            about: 'عن التطبيق',
            blog: "المدونة",
            specialties: 'التخصصات',
            featured_specialties: 'التخصصات المميزة',
            doctors: 'الأطباء',
            contact: 'اتصل بنا',
            offers: 'العروض',
            offer: 'العرض',
            login: "تسجيل الدخول",
            cash_back: "كاش باك",
            visit_day: "يوم الزيارة",
            add_review: "أضف تقييمك",
            canceled: "تم الإلغاء",
            my_appointment: "مواعيدى",
            rate_doctor: "تقييم الطبيب",
            write_review: "اكتب تقييمك",
            write_your_review_here: "اكتب رأيك هنا",
            thank_you: "شكرا لك",
            review_added_successfully: "تم إضافة رأيك بنجاح",
            sorry: "نأسف",
            forget_password: "نسيت كلة المرور",
            new_password: "كلمة مرور جديدة",
            points: "النقاط",
            logout: "تسجيل الخروج",
            profile: "الصفحة الشخصية ",
            verify_code: "التحقق من الكود",
            type: "النوع",
            resend_code: "إعادة إرسال الكود",
            mobileValidationMsg: "الرجاء إطالة هذا النص الي 11 رقماًأو أكثر ",
            fees_included: "شاملة الرسوم",
            keywordPlaceHolder: "هل تعرف اسم الطبيب؟",
            edit: "تعديل",
            recommended_by: "تم الترشيح بواسطة",
            reviews: "التقييم",
            premium_fees: "السعر المميز",
            show_more: "اعرض المزيد",
            show_less: "عرض اقل ",
            please_login: "برجاء تسجيل الدخول لمتابعه هذا الطبيب",
            history: "تاريخ الزيارات",
            load_more: "تحميل المزيد",
            book_now: "احجز الآن",
            open_app: "افتح الابليكشن",
            login_first: "يجب تسجيل الدخول أولا",
            link_copied: "تم نسخ الرابط بنجاح",
            expires_on: "انتهاء الصلاحية في",
            days: "أيام",
            offer_category: "فئة العرض",
            speciality: "التخصص",
            subtotal_fees: "مجموع الرسوم",
            total_fees: "الإجمالي النهائي للرسوم ",
            cash_back_requested_successfully: "تم طلب الكاش باك بنجاح",
            copy_offer_link: "نسخ رابط العرض",
            copy_doctor_profile_link: "نسخ رابط الصفحة الشخصية للطبيب",
            doctor_profile_link_copied_successfully: "تم نسخ رابط الصفحة الشخصية للطبيب بنجاح",
            offer_link_copied_successfully: "تم نسخ رابط العرض بنجاح ",
            share_on: "مشاركة في",
            verify: "التحقق",
            verified: "تم التحقق",
            become_premium_by_sharing: "احصل علي العضوية المميزة عن طريق مشاركة........0.",
            become_premium_by_sharing_text: "احصل علي العضوية المميزة عن طريق دعوة اصدقاءك للتسجيل في تطبيق سينا عندما يقوم احد اصدقاءك بالتسجيل عن طريق كود الدعوة الخاص بك فإنهم يحصلون علي شهر في العضوية المميزة مجانا، بمجرد تسجيل احدهم بالكود الخاص بك تحصل انت ايضا علي شهر مجانا يمكنك مشاركة الكود الخاص بك مع اصدقاءك عن طريق الضغط علي شارك الان واختيار احد خيارات النشر المتاحة.",
            you_logged_in_successfully: "تم تسجيل دخولك بنجاح ",
            /********************************************************************* Page Titles ***************************************************************************************/
            home_title: "ادخر وقتك و فلوسك",
            about_title: "عن التطبيق",
            contact_title: "اتصل ",
            doctors_title: "احجز مع طبيبك بسهولة",
            specialties_title: "التخصصات",
            privacy_title: 'سياسة الخصوصية ',
            terms_title: "الشروط والإتفاق",
            blog_title: "المدونة",
            offers_title: "العروض",
            join_our_doctors_title: "انضم إلي أطبائنا الآن واستمتع بمزايانا",
            doctors_favourite_title: "Helping Doctor Save Lives",
            offer_details_title: "تفاصيل العرض",
            blog_category_title: "فئات المدونة",
            blog_tag_title: "علامات المدونة",
            blog_post_title: "مشاركة المدونة",
            profile_title: 'الصفحة الشخصية',
            my_appointments_title: 'المواعيد',
            download_title: "تحميل التطبيق",
            single_doctor_title: "الطبيب",
            premium_title: "الفئة المميزة ",
            cash_back_title: "الكاش باك",
            login_title: "تسجيل الدخول",
            register_title: "التسجيل",
            activate_title: "تفعيل",
            forget_password_title: 'نسيت كلمة المرور',
            reset_password_title: ' إعادة تعيين كلمة المرور',
            no_match_title: "404",
            /******************************************************************** slider ***************************************************************************/


            // Subscribe
            subscribe: "الاشتراك",
            subscribe_Text: "للحصول علي آخر الأخبار والعروض برجاء الاشتراك بالبريد الالكتروني الخاص بك.",
            enter_your_email_address: "قم بإدخال بريدك الشخصي",


            // specialties
            specialities: "التخصصات",


            /*****************Contact Us*********************/
            Contact_Information: "معلومات التواصل",
            address: "العنوان",
            address_details: "21ابراهيم الرفاعي،مدينة نصر،القاهرة",
            name: "الاسم",
            email: "البريد الشخصي",
            mobile: "رقم التليفون",
            message: "الرسالة",
            send_message: "أرسل رسالة",

            /*****************Footer*********************/
            important: "مهم",
            how_to_register: "كيفية التسجيل?",
            already_have_account: "هل لديك حساب بالفعل ؟ ",
            privacy_policy: "سياسة الخصوصية",
            site_links: "روابط الموقع",
            have_questions: "لديك استفسار؟",
            copyright: "جميع حقوق الطبع والنشر محفوظة لدي آركيه أنجيل",
            premium_footer: "الفئة المميزة",
            points_footer: "النقاط",
            /**************************************************************** */
            /*************************************************************** */

            /********** About Rklinic *************** */
            about_header: "مرحبا بك في نقطة الإلتقاء الطبية",
            about_paragragh_1: "طبيب أو مريض ،ماذا يمكن أن يكون أفضل من تطبيق مخصص فقط لأجلك ؟لقد انشأت سينا تطبيق سيساعد الأطباءومرضاهم علي التواصل بشكل أسهل وأفضل.تعرف علي تطبيقك ومميزاته",
            about_paragragh_2: "تم تقديم تطبيقنا للأطباءالذين يهتمون بالعمل ويسعون جاهدين لمساعدة الناس ، سيساعد ذلك الأطباء علي تهيئة بيئة مريحة للمرضي كي يشعروابأنهم أقرب وأكثر ارتباطا بالعملية الطبية بأكملها.",


            /************************* General Translations */
            phone: " الهاتف ",
            book: "الحجز",
            fetch_more: "اعرض المزيد",
            no_data: "لا يوجد بيانات للعرض  ..",
            fees: 'الكشف',
            followers: 'المتابعين',
            msg_sent: "تم إرسال الرسالة",
            msg_sent_details: "تم إرسال الرسالة بنجاح ..",
            doctors_will_be_here: "أطبائنا سيكونون هنا ..",
            currency: "جنيه",
            advance_filter: "تنقية البحث",
            aToz: "ترتيب من (أ:ي)",
            zToa: "ترتيب من (أ:ي)",
            select_specialty: "اختر التخصص",
            recommendations: "الترشيحات",
            sort: "ترتيب",
            doctor_name: "اسم الطبيب",
            city: "المدينة",
            province: "المحافظة",
            specialty: "التخصص",
            poly_clinics: "عيادة متعددة التخصصات",
            404: "خطأ 404",
            page_not_found: "لا يمكن العثور علي الصفحة التي تبحث عنها ",
            booking_is_not_available: "الحجز غير متاح حتي الآن",
            sponsored: "إعلان",
            off: "خصم",
            not_login_request_plan_title: "أنت زائر",
            not_login_request_plan_text: "يجب تسجيل الدخول أولا",
            change_plan_request_title: "قم بتغيير فئة اشتراكك ",
            change_plan_request_text: "هل أنت متأكد من تغيير فئة اشتراكك?",
            /************************************Home***********************/
            /************Intro*************/
            home_intro_title: "توفير الوقت والمال علي الخدمات الطبية الخاصة بك ",
            home_intro_sub_title: "نحن معك سواء كان معك تأمين طبي او في انتظار الموافقة الطبية",
            search_for_doctors: "احجز الآن",

            /***************WorkProcess*********/
            work_process_header: "كيف تستخدم سينا؟",
            wp_search_for_doctor: "أختر الطبيب ",
            wp_search_for_doctor_desc: "أختر الطبيب",
            wp_cash_back: "كاش باك",
            wp_cash_back_desc: "احصل علي كاش باك مقابل حجز العروض ",
            wp_book_appointment: "تغيير الميعاد",
            wp_book_appointment_desc: "تغيير ميعاد حجزك",
            wp_track_visit: "تابع دورك ",
            wp_track_visit_desc: "تابع دورك واحفظ وقتك",

            /***************Offer*********/
            offer_header: "عروضنا",

            /***************Blog*********/
            blog_header: "أحدث المدونات",

            /************************************Doctor***********************/
            search: "البحث",
            followed_by: " متابع بواسطة",
            min_fees: "الحد الأدني للرسوم",
            user: "المستخدم",
            upcoming: "التالي",
            past: "السابق",
            get_cash_back: "احصل علي كاش باك",
            not_enough_points: "لا يوجد رصيد كافي",
            /************************************Single Doctor***********************/
            cancel: "إلغاء",
            check_up: "الكشف",
            follow_up: "المتابعة",
            write_complaint: "اكتب الشكوي.. ",
            vat: "الضريبة",
            discount: "الخصم",
            total: "الإجمالي",
            submit: "التأكيد",
            approved: "الموافقة",
            patient_number: "رقم المريض",
            now_serving: "الرقم الحالي هو",
            track_reservation: "تابع حجزك  حمل تطبيق سينا",
            download: "تحميل",
            here: "هنا",
            done: "تم",
            premium: "الفئة المميزة",
            doctor: "الطبيب",
            biography: "السيرة الذاتية",
            services: "الخدمات",
            choose_day: "اختر اليوم",
            choose_time: "اختر الوقت",
            previous: "السابق",
            next: "التالي",
            from: "من",
            to: "إلي",
            queue_reservation_hint: "تم حجزه أولا",
            interval_reservation_hint: "الحضور في وقت معين",
            break_times: "وقت الراحة",
            view: "الرأي",
            views: "الآراء",
            insurance_companies: "شركات التأمين",
            clinic_gallery: "صور العيادة",
            /************************BLOG******************************/
            website: "الموقع",
            your_comment: "تعليقك",
            post_comment: "أضف تعليقاً",
            categories: "الفئات",
            tag_cloud: "Tag Cloud",
            reply: "الرد",
            leave_reply: "ضع رداً",
            comments: "التعليقات",
            leave_comment: "ضع تعليقا",

            /********************Offer******************************/
            get_offer: "احصل علي العرض",
            users_booked: "عدد الحجوزات",
            /******************ActivateForm******************************/
            code_not_match: "الرمز غير متطابق",
            activate: "التفعيل",
            back_to_home: "الرجوع الي الصفحة الرئيسية",

            /******************Login******************************/
            sign_up_now_ques: "قم بإنشاء حساب الآن ?",
            forget_your_password_ques: "هل نسيت كلمة المرور؟",

            /******************Register******************************/
            register: "التسجيل",
            sign_up: "التسجيل",
            have_account_ques: " هل لديك حساب ؟",

            /******************Download******************************/
            download_seena_app: "حمل تطبيق سينا الآن",
            available_on_store: "متاح الآن علي متجرالاندرويد والأي فون.",
            free_download_desc: " سينا مجاني للتحميل والاستخدام.ابحث عن الاطباء في العديد من التخصصات ",
            seena_for_doctors_available: "تطبيق سينا للأطباء متاح الآن",
            seena_for_doctors: "تطبيق سينا للأطباء",
            seena_for_doctors_desc: "يقدم لك تطبيقنا احترافية لإدارة حسابك, ",
            seena_for_doctors_desc_two: "مع الأخذ في الاعتبار انه قوي وسهل الاستخدام.",
            ios: "أيفون",
            android: "أندرويد",
            sign_up_now: "سجل الآن",

            /******************premium benefits******************************/
            benefits: "الفوائد",
            enjoy_unlimited_discount: "استمتع بخصومات غير محدودة",
            no_medical_approval: "لا يوجد موافقط طبية",
            no_medical_approval_desc: "احصل علي خصومات علي الخدمات الطبية التي لا تحتاج إلي موافقة علي التأمين الطبي .",
            special_discounts: "خصومات خاصة",
            special_discounts_desc: "وفر المزيد من المال علي أسعار الأطباء من خلال خصم إضافي .",
            personal_data: "البيانات الشخصية",
            personal_data_desc: "احتفظ بسجلاتك الإلكترونية معك في كل مكان تذهب إليه.",
            all_terrain_suitability: "نقاط المكافأة",
            all_terrain_suitability_desc: "احصل علي المزيد من النقاط بنفس المبلغ الذي أنفقته في عيادتك.",
            upgrade_now: "قم بالتحديث الآن",

            /******************Profile******************************/
            followed_doctors: "الأطباء المتابعين",
            edit_profile: "تعديل الصفحة الشخصية",
            main_info: "البيانات الأساسية",
            extras: "إضافات",
            months: "أشهر",
            gender: "النوع",
            male: "ذكر",
            female: "أنثي",
            height: "الطول",
            weight: "الوزن",
            birthday: "تاريخ الميلاد",
            upgrade_to_premium: "الاشتراك في الفئة المميزة",
            upcoming_appointments: "المواعيد القادمة",
            delete: "إلغاء",
            reschedule: "إعادة حجز ميعاد",
            completed: "مكتمل",
            not_found: "لم يتم العثور عليه",
            from_points: "من : ",
            to_points: "إلي : ",
            cancel_reservation: "إلغاء الحجز",
            /*********************************POINTS**********************/
            points_title: "اكسب كاش باك لتستفيد بالفوائد",
            points_benefit_one: "خصومات إضافية",
            points_benefit_one_desc: "احصل علي خصومات تصل ل 50% من الأطباء في شبكة الفئة المميزة",
            points_benefit_two: "كاش باك إضافي",
            points_benefit_two_desc: "احصل علي 3% كاش باك علي كل تحويلاتك من خلال سينا",
            points_benefit_three: "منتجات إضافية",
            points_benefit_three_desc: "يمكنك الوصول الي المزيد من المنتجات في المتجر لاسترداد نقاطك",
            points_benefit_four: "كشوفات مجانية",
            points_benefit_four_desc: "احصل علي كشوفات مجانية من الاطباء الموجودين في شبكة أطبائنا المميزة",
            get_plan_with_points: "أو يمكنك الحصول عليها من خلال",
            get_plan: "الحصول علي خطة",
            point_s: "النقطة(النقاط)",
            credit_card: "البطاقة الإئتمانية",
            get_more_points: "احصل علي المزيد من النقاط",
            ok: "حسنا",
            something_wrong: "عذرا..حدث خطأ ما",
            join_our_doctors: "انضم إلي أطبائنا",
            are_you_sure_ques: "هل أنت متأكد ؟ ",
            cancel_plan_sweet_alert_title: "إلغاء الخطة! ",
            cancel_plan_sweet_alert_text: "هل أنت متأكد من إلغاء خطتك ؟",
            expired_on: "انتهت يوم",
            success_plan: "لقد قمت بالتحديث إلي هذه الخطة بنجاح",
            success: "نجاح",
            get_points: "الحصول علي نقاط",
            top_offers: "أفضل العروض",
            Book_in_branch: "احجز فى",
            contact_address: " : العنوان",
            contact_phone: "الهاتف: ",
            contact_email: "البريد الإلكتروني: ",
            branch_info: "تفاصيل فرع",
            premium_users_only: "مستخدمين الفئة المميزة فقط",
            search_for_doctor: "البحث عن طبيب",
            find_the_best_doctor_now_easily: "العثور علي أفضل طبيب الآن بسهولة",
            find_doctor_now: "العثور علي طبيب الآن",
            account: "الحساب",
            create_account: "قم بإنشاء حساب",
            opps_page_is_not_available: "الصفحة غير متاحة",
            reload: "إعادة التحميل",


            active: "نشط",
            active_account: "حساب نشط",
            activated_successfully: "تم التفعيل بنجاح",

            auth_pop_up_sweet_alert_title: "دخول سريع",
            auth_pop_up_sweet_alert_text: "يجب تسجيل الدخول أو انشاء حساب للحجز",
            activation_pop_up_sweet_alert_title: "حجز مستعجل",
            activation_pop_up_sweet_alert_text: "يجب تفعيل حسابك للحجز",

            go_home: "الذهاب للصفحة الرئيسية",

            payment_terms_title: "الأحكام وشروط الدفع",


            add_services: "اضافة خدمة",

            optional: "اختيارى",

            discount_premium_user: "هذا الخصم متاح فقط للعملاء المميزين",


            are_you_sure: "هل انت متآكد ؟",
            are_you_sure_you_want_get_this_plan: "هل انت متآكد من اختيار هذه الخطة",
            yes: "نعم",

            report: "شكوى",
            missed: "مفقود",
            review: "تقييم",
            ad: "إعلان",
            top_viewed: "الأعلى زيارة",
            refund: "اعادة المال",
            why_do_you_want_to_report_this_visit : "لماذا تريد ان تقدم شكوى فى هذه الزيارة ؟",
            select_issue: "اختار شكوتك",
            help: "مساعدة",
            or_call_us: "أو اتصل بنا",
            report_added_successfully: "تم ارسال شكوتك بنجاح",

            promo_code: "كود الخصم",
            enter_your_promo_code: "ادخل كود الخصم",
            redeem: "تفعيل",

            payment_methods: "طرق الدفع",
            cash: "كاش",
            instalment: "تقسيط",
            cash_back_desc: "سوف تحصل على ١٠٪ من قيمة المبلغ",
            instalment_desc: "يمكنك استخدام هذا الاختيار مع اماكن معينة.",
            code_required: "برجاء ادخال الكود",

            all: "الكل",
            most_viewed: "الآكثر زيارة",
            agree: "موافق",
            request_refund_success: "لقد تم تنفيذ طلبك بنجاح",
            dont_agree: "غير موافق",
            transaction_id: "transaction id",
            expires_today: "expires_today",
            refund_des : "إذا كنت مريضًا وتعاني من مشكلة في الحجز ، فإننا نوافق ، وفقًا لتقديرنا ، على إما (1) تعويضك بالمبلغ الذي دفعته من خلال منصة Seena (“الرسوم الإجمالية أو أقل“) وفقًا لطبيعة عانى حجز القضية ،",

            different_specialities: "متعددة التخصصات",
            branch: "فرع",

        }
    }
};